import { render, staticRenderFns } from "./NachbestellungArtikelEdit.vue?vue&type=template&id=15aa3429"
import script from "./NachbestellungArtikelEdit.vue?vue&type=script&lang=ts"
export * from "./NachbestellungArtikelEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports